import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

import storage from './storage'

// import Auth views
import Login from '@imemento/spa-helpers/src/views/auth/Login'
import RecoverPassword from '@imemento/spa-helpers/src/views/auth/RecoverPassword'
// import Register from '@imemento/spa-helpers/src/views/auth/Register'
import ResetPassword from '@imemento/spa-helpers/src/views/auth/ResetPassword'
import InsufficientPrivileges from '@imemento/spa-helpers/src/views/auth/InsufficientPrivileges'

// import App views
import Dashboard from './views/app/Dashboard.vue'
import Sheet from './views/app/Sheetv2.vue'
import SheetRoomMeal from './views/app/SheetRoomMealv2.vue'
import Distribution from './views/app/Distribution.vue'
import CancellationPolicies from './views/app/CancellationPolicies.vue'
import CancellationPolicy from './views/app/CancellationPolicy.vue'
import Hotel from './views/app/Hotel.vue'
import HotelCards from './views/app/HotelCards.vue'
import Hotels from './views/app/Hotels.vue'
import RatePlans from './views/app/RatePlans.vue'
import RatePlan from './views/app/RatePlan.vue'
import Reservations from './views/app/Reservations.vue'
import DialogItem from './components/items/Reservations/DialogItem.vue'
import RoomTypes from './views/app/RoomTypes.vue'
import RoomType from './views/app/RoomType.vue'

import RegisterHotel from './views/register/Register.vue'

// import Healthy view
import Healthy from '@imemento/spa-helpers/src/views/healthy/Healthy'

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/authentication/login',
      component: Login,
      meta: { private_route: false }
    },
    {
      path: '/authentication/recover-password',
      component: RecoverPassword,
      meta: { private_route: false }
    },
    {
      path: '/authentication/register',
      // component: Register,
      component: RegisterHotel,
      meta: { private_route: false }
    },
    {
      path: '/authentication/reset-password',
      component: ResetPassword,
      meta: { private_route: false }
    },
    {
      path: '/authentication/insufficient-privileges',
      component: InsufficientPrivileges,
      meta: { private_route: false }
    },
    {
      path: '/healthy',
      component: Healthy,
      meta: { private_route: false }
    },
    {
      path: '/',
      redirect: '/dashboard',
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/:hotel_slug/inventory-pricing',
      name: 'Sheet',
      component: Sheet,
      props: { default: true},
      meta: { private_route: true }
    },
    {
      path: '/:hotel_slug/pricing-rooms-meals',
      name: 'Sheet Room and Meals',
      component: SheetRoomMeal,
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/:hotel_slug/cancellation-policies',
      name: 'Cancellation Policies',
      component: CancellationPolicies,
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/:hotel_slug/cancellation-policies/create',
      name: 'Add New Cancellation Policies',
      component: CancellationPolicy,
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/:hotel_slug/cancellation-policies/:id',
      name: 'Edit Cancellation Policies',
      component: CancellationPolicy,
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/hotel/:id',
      name: 'Edit hotel',
      component: HotelCards,
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/hotels',
      name: 'Hotels',
      component: Hotels,
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/hotel',
      name: 'Add hotel',
      component: Hotel,
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/:hotel_slug/rate-plans',
      name: 'Rate Plans',
      component: RatePlans,
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/:hotel_slug/rate-plans/create',
      name: 'Add Rate Plan',
      component: RatePlan,
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/:hotel_slug/rate-plans/:id',
      name: 'Edit Rate Plan',
      component: RatePlan,
      meta: { private_route: true }
    },
    {
      path: '/:hotel_slug/reservations',
      name: 'Reservations',
      component: Reservations,
      props: { default: true },
      meta: { private_route: true },
      children: [
          {
              path: ':reservation_id',
              name: 'DialogItem',
              component: DialogItem,
              props: { default: true },
              meta: { private_route: true },
          }
      ]
    },
    {
      path: '/:hotel_slug/room-types',
      name: 'Room Types',
      component: RoomTypes,
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/:hotel_slug/room-types/create',
      name: 'Add Room Type',
      component: RoomType,
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/:hotel_slug/room-types/:id',
      name: 'Edit Room Type',
      component: RoomType,
      props: { default: true },
      meta: { private_route: true }
    },
    {
      path: '/:hotel_slug/distribution',
      name: 'Channel Manager',
      component: Distribution,
      props: { default: true },
      meta: { private_route: true }
    },
    // catch all redirect
    {
      path: '*',
      redirect: '/dashboard',
      props: { default: true },
      meta: { private_route: true }
    },
  ]
});

// router before middleware
router.beforeEach(async (to, from, next) => {
    
  if (to.path === '/healthy') {
    return next();
  }

  let token = await storage.getToken();
  let roles = await storage.getRoles();

  if (!token && to.meta.private_route ) {
    localStorage.setItem('path', to.path);
    return next('/authentication/login');
  }

  //to do must be spa_console
  if ((!roles || !roles.ssr_console ||!(roles.ssr_console.includes('admin') || roles.ssr_console.includes('user'))) && to.meta.private_route) {
    return next('/authentication/insufficient-privileges');
  }
  
   return next();
});

export default router;
